"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidSkeletonType = void 0;
var FluidSkeletonType;
(function (FluidSkeletonType) {
    FluidSkeletonType["CARD"] = "card";
    FluidSkeletonType["TEXT"] = "text";
    FluidSkeletonType["IMAGE"] = "image";
    FluidSkeletonType["CIRCLE"] = "circle";
    FluidSkeletonType["CARD_FULL_WIDTH"] = "card-full-width";
    FluidSkeletonType["TABLE"] = "table";
    FluidSkeletonType["TABLE_LEFT"] = "table-left";
    FluidSkeletonType["TABLE_RIGHT"] = "table-right";
    FluidSkeletonType["BUTTON"] = "button";
    FluidSkeletonType["BUTTON_GROUP"] = "button-group";
    FluidSkeletonType["HEADER"] = "header";
    FluidSkeletonType["FORM"] = "form";
})(FluidSkeletonType = exports.FluidSkeletonType || (exports.FluidSkeletonType = {}));
